import { useCallback, useEffect, useState } from "react"
import { get } from "helpers/api_helper"
import { settling } from "./publishingLabels"

const DELIVERY_POLL_MS = 3000
const POLLS = 20

// The organizers' emails of a publish with how each goes now (E1p pinned decision Q2: the operation read of a publication adds each email's
// delivery), read until each has settled — delivered, failed or unconfirmed — every 3 s for a minute at most, and again on demand (`again`,
// after a resend or "Check again").
export default function usePublicationEmails(result) {
  const [emails, setEmails] = useState(result?.emails || [])
  const [round, setRound] = useState(0)
  const [polling, setPolling] = useState(false)
  const again = useCallback(() => setRound(value => value + 1), [])
  useEffect(() => { setEmails(result?.emails || []) }, [result])
  useEffect(() => {
    if (!result?.operationId || !(result.emails || []).some(({ publicationId }) => publicationId)) return undefined
    let active = true, timer = null, polls = 0
    const poll = async () => {
      let read = null
      try { read = (await get(`/admin/tournament-proposal-operations/${result.operationId}`))?.data } catch { /* The next read tries again. */ }
      if (!active) return
      if (Array.isArray(read?.emails)) setEmails(read.emails)
      polls += 1
      const more = polls < POLLS && (!Array.isArray(read?.emails) || read.emails.some(settling))
      setPolling(more)
      if (more) timer = setTimeout(poll, DELIVERY_POLL_MS)
    }
    setPolling(true)
    poll()
    return () => { active = false; clearTimeout(timer) }
  }, [result, round])
  return { emails, polling, again }
}
